import styled from "@emotion/styled/macro";
import { VaultListItemWrapper } from "../VaultListItem/VaultListItem.styles";

export const VaultAnalyzeCompleteStatusWrapper = styled.div`
    display: flex;
    height: 28px;
    padding: 0px 12px 0px 8px;
    align-items: center;
    gap: 6px;

    border-radius: 37px;

    ${VaultListItemWrapper}:hover & {
        background: #E9EAEB;
    }
`;

export const VaultInProgressStatusWrapper = styled.div`
    display: flex;
    height: 28px;
    padding: 0px 12px;
    align-items: center;
    gap: 6px;

    border-radius: 37px;
    background: #F1F3F5;

    ${VaultListItemWrapper}:hover & {
        background: #E9EAEB;
    }
`;